import { z } from 'zod'

export const COACHING_SHELL_CAPSTONE_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellCapstoneResponseSchema = z.unknown()
export type CoachingShellCapstoneResponse = z.infer<typeof coachingShellCapstoneResponseSchema>
